import { type FC, type PropsWithChildren } from 'react'
import classNames from 'classnames'

interface InfoBoxProps extends PropsWithChildren {
  variant?: 'primary' | 'info'
}

export const InfoBox: FC<InfoBoxProps> = ({ variant = 'primary', children }) => {
  const isPrimary = variant === 'primary'

  return (
    <div
      className={classNames(
        'd-flex align-items-center zocks-gap-0.75 zocks-px-0.75 py-2 border rounded-3',
        isPrimary ? 'zocks-bg-color-primary-light zocks-border-color-primary' : 'zocks-bg-color-gray-100 zocks-border-color-gray-200',
      )}
    >
      <i className={classNames('bi bi-info-square fs-6 flex-shrink-0', isPrimary ? 'zocks-text-primary' : 'zocks-text-gray-700')} aria-hidden />
      <div className='flex-1 mw-0 paragraph-small zocks-text-gray-900'>{children}</div>
    </div>
  )
}
